var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.541 0.959338C14.4153 0.83367 14.2583 0.743797 14.0862 0.698976C13.9142 0.654154 13.7333 0.656005 13.5623 0.704338H13.5529L1.55663 4.34434C1.36135 4.4005 1.18781 4.51481 1.05912 4.67206C0.930437 4.82931 0.852706 5.02202 0.836281 5.22455C0.819856 5.42708 0.865517 5.6298 0.967184 5.80573C1.06885 5.98166 1.2217 6.12245 1.40538 6.20934L6.75663 8.74371L9.291 14.095C9.37102 14.2663 9.49839 14.4112 9.65808 14.5126C9.81777 14.6139 10.0031 14.6674 10.1923 14.6668C10.221 14.6668 10.2498 14.6656 10.2785 14.6631C10.4803 14.6467 10.6723 14.5691 10.8287 14.4405C10.9851 14.3119 11.0984 14.1386 11.1535 13.9437L14.791 1.94746C14.791 1.94434 14.791 1.94121 14.791 1.93809C14.84 1.76744 14.8426 1.58683 14.7987 1.41482C14.7547 1.24281 14.6658 1.0856 14.541 0.959338ZM10.1979 13.6575L10.1948 13.6662L7.73475 8.47309L10.6873 5.51996C10.7771 5.42543 10.8264 5.29956 10.8247 5.16918C10.8231 5.03879 10.7705 4.91422 10.6783 4.82202C10.5861 4.72982 10.4615 4.67729 10.3312 4.67562C10.2008 4.67395 10.0749 4.72328 9.98038 4.81309L7.02725 7.76559L1.8335 5.30559H1.84225L13.8335 1.66684L10.1979 13.6575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentIcon);
export default __webpack_public_path__ + "static/media/sent-icon.39d4ff2b8fb1606d9f6936b5a46dbb93.svg";
export { ForwardRef as ReactComponent };